/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Type of the example (file or directory) 
*/
export enum PathType {
  File = 'FILE',
  Directory = 'DIRECTORY'
}
